import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsAfter } from "../../dateutil";
import moment from 'moment-timezone';

class AfterDateTimeEx extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      const current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD h:mm a');
      const compare = moment(validation.value).utcOffset(moment(validation.value).utcOffset()).format('YYYY-MM-DD  h:mm a');
      if ( !dateIsAfter(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_AFTER_SPECIFIED_DATE_EX',
          values: { value: validation.value },
          message: `Value should be after '${compare}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default AfterDateTimeEx;
